<template>
  <img v-if="src" :src="src" :alt="alt" :class="class" />
  <img v-else src="@/assets/images/iconSvg/logo_no_pic.svg" :alt="alt" :class="class" />
</template>

<script setup>
defineProps({
  src: {
    type: String,
    default: ''
  },
  alt: {
    type: String,
    default: ''
  },
  class: {
    type: String,
    default: ''
  }
})
</script>
